import { useEffect } from 'react';
import actionsSimCards from '../../../api/actionsSims';
import CustomPaySelectOffer from '../../forms/CustomPaySelectOffer';
import { useMemo } from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import CUSTOM_PAY_SIM_OFFERS_PROVIDERS from '../../../enums/CustomPaySimOffersProviders';



/**
 *
 * @param root0
 * @param root0.step
 * @param root0.stepData
 * @param root0.setStepData
 * @returns {JSX} SimImportSelectProvider
 */
function SimImportSelectProvider({
    step,
    stepData,
    setStepData
}) {

    // State
    const [selectedProvider, setSelectedProvider] = useState(stepData[step] || undefined);

    // API Calls get Sim Providers
    const { data, isLoading } = actionsSimCards.getSimProviders();


    // Hooks
    const simProviders = useMemo(() => {
        return data?.simProviders?.map((provider) => {
            return {
                name: CUSTOM_PAY_SIM_OFFERS_PROVIDERS[provider.providerName]?.name,
                value: CUSTOM_PAY_SIM_OFFERS_PROVIDERS[provider.providerName]?.key
            };
        });
    }, [data?.simProviders]);


    useEffect(() => {
        if (selectedProvider) {
            setStepData({ ...stepData, [step]: selectedProvider });
        }
    }, [selectedProvider]);


    return <CustomPaySelectOffer
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        simProviders={simProviders}
        isLoading={isLoading}
    />;
}

SimImportSelectProvider.propTypes = {
    step: PropTypes.number.isRequired,
    stepData: PropTypes.object.isRequired,
    setStepData: PropTypes.func.isRequired
};

export default SimImportSelectProvider;